import { render, staticRenderFns } from "./contentCourseLecturePhoto.vue?vue&type=template&id=1e3af216&"
import script from "./contentCourseLecturePhoto.vue?vue&type=script&lang=js&"
export * from "./contentCourseLecturePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports